/**
 * @generated SignedSource<<eac256b5971d06c64c76318889e5a0cd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GoalDirectoryQuery$variables = {
  aaid?: string | null;
  containerId?: string | null;
  workspaceId?: string | null;
  workspaceUuid?: string | null;
};
export type GoalDirectoryQuery$data = {
  readonly customFieldDefinitionTql: {
    readonly " $fragmentSpreads": FragmentRefs<"buildCustomFieldResolvers">;
  } | null;
  readonly customfieldHeaderSupport: {
    readonly " $fragmentSpreads": FragmentRefs<"GoalDirectoryHeaderColumns">;
  } | null;
  readonly hasGoals: {
    readonly hasRecords: boolean;
  } | null;
  readonly reportingLines: {
    readonly managers: ReadonlyArray<{
      readonly __typename: "ReportingLinesUser";
    } | null> | null;
    readonly peers: ReadonlyArray<{
      readonly __typename: "ReportingLinesUser";
    } | null> | null;
    readonly reports: ReadonlyArray<{
      readonly __typename: "ReportingLinesUser";
    } | null> | null;
  } | null;
};
export type GoalDirectoryQuery = {
  response: GoalDirectoryQuery$data;
  variables: GoalDirectoryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "aaid"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceUuid"
},
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v5 = [
  (v4/*: any*/)
],
v6 = {
  "args": [
    {
      "kind": "Variable",
      "name": "aaidOrHash",
      "variableName": "aaid"
    }
  ],
  "concreteType": "ReportingLines",
  "kind": "LinkedField",
  "name": "reportingLines",
  "plural": false,
  "selections": [
    {
      "concreteType": "ReportingLinesUser",
      "kind": "LinkedField",
      "name": "managers",
      "plural": true,
      "selections": (v5/*: any*/)
    },
    {
      "concreteType": "ReportingLinesUser",
      "kind": "LinkedField",
      "name": "peers",
      "plural": true,
      "selections": (v5/*: any*/)
    },
    {
      "concreteType": "ReportingLinesUser",
      "kind": "LinkedField",
      "name": "reports",
      "plural": true,
      "selections": (v5/*: any*/)
    }
  ]
},
v7 = {
  "kind": "Variable",
  "name": "containerId",
  "variableName": "containerId"
},
v8 = {
  "args": [
    (v7/*: any*/),
    {
      "kind": "Literal",
      "name": "includeArchived",
      "value": false
    },
    {
      "kind": "Variable",
      "name": "workspaceId",
      "variableName": "workspaceId"
    }
  ],
  "concreteType": "HasRecords",
  "kind": "LinkedField",
  "name": "hasGoals",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasRecords"
    }
  ]
},
v9 = {
  "kind": "Variable",
  "name": "workspaceUuid",
  "variableName": "workspaceUuid"
},
v10 = [
  (v7/*: any*/),
  {
    "kind": "Literal",
    "name": "q",
    "value": "(entityType = GOAL AND (type != String OR hasPredefinedValues = true))"
  },
  (v9/*: any*/)
],
v11 = {
  "kind": "ScalarField",
  "name": "name"
},
v12 = {
  "kind": "ScalarField",
  "name": "token"
},
v13 = {
  "kind": "ScalarField",
  "name": "canSetMultipleValues"
},
v14 = {
  "kind": "ScalarField",
  "name": "value"
},
v15 = [
  (v7/*: any*/),
  {
    "kind": "Literal",
    "name": "q",
    "value": "entityType = GOAL"
  },
  (v9/*: any*/)
],
v16 = {
  "kind": "ScalarField",
  "name": "id"
},
v17 = {
  "kind": "InlineFragment",
  "selections": [
    (v16/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v18 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v19 = {
  "kind": "ScalarField",
  "name": "type"
},
v20 = [
  (v18/*: any*/),
  (v11/*: any*/),
  (v19/*: any*/)
],
v21 = [
  (v18/*: any*/),
  (v11/*: any*/),
  (v19/*: any*/),
  (v13/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "GoalDirectoryQuery",
    "selections": [
      (v6/*: any*/),
      (v8/*: any*/),
      {
        "args": (v10/*: any*/),
        "concreteType": "CustomFieldDefinitionConnection",
        "kind": "LinkedField",
        "name": "customFieldDefinitionTql",
        "plural": false,
        "selections": [
          {
            "kind": "InlineDataFragmentSpread",
            "name": "buildCustomFieldResolvers",
            "selections": [
              {
                "concreteType": "CustomFieldDefinitionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "buildCustomFieldResolvers_userResolver",
                            "selections": [
                              (v4/*: any*/),
                              (v11/*: any*/),
                              (v12/*: any*/),
                              (v13/*: any*/)
                            ],
                            "argumentDefinitions": []
                          }
                        ],
                        "type": "UserCustomFieldDefinition"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "buildCustomFieldResolvers_textSelectResolver",
                            "selections": [
                              (v4/*: any*/),
                              (v11/*: any*/),
                              (v12/*: any*/),
                              (v13/*: any*/),
                              {
                                "concreteType": "CustomFieldTextAllowedValueConnection",
                                "kind": "LinkedField",
                                "name": "allowedValues",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "CustomFieldTextAllowedValueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "CustomFieldTextAllowedValueNode",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v14/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ],
                            "argumentDefinitions": []
                          }
                        ],
                        "type": "TextSelectCustomFieldDefinition"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "buildCustomFieldResolvers_numberResolver",
                            "selections": [
                              (v4/*: any*/),
                              (v11/*: any*/),
                              (v12/*: any*/)
                            ],
                            "argumentDefinitions": []
                          }
                        ],
                        "type": "NumberCustomFieldDefinition"
                      }
                    ]
                  }
                ]
              }
            ],
            "argumentDefinitions": []
          }
        ]
      },
      {
        "alias": "customfieldHeaderSupport",
        "args": (v15/*: any*/),
        "concreteType": "CustomFieldDefinitionConnection",
        "kind": "LinkedField",
        "name": "customFieldDefinitionTql",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "GoalDirectoryHeaderColumns"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "GoalDirectoryQuery",
    "selections": [
      (v6/*: any*/),
      (v8/*: any*/),
      {
        "args": (v10/*: any*/),
        "concreteType": "CustomFieldDefinitionConnection",
        "kind": "LinkedField",
        "name": "customFieldDefinitionTql",
        "plural": false,
        "selections": [
          {
            "concreteType": "CustomFieldDefinitionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/)
                    ],
                    "type": "UserCustomFieldDefinition"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      {
                        "concreteType": "CustomFieldTextAllowedValueConnection",
                        "kind": "LinkedField",
                        "name": "allowedValues",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "CustomFieldTextAllowedValueEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "CustomFieldTextAllowedValueNode",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v14/*: any*/),
                                  (v16/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ],
                    "type": "TextSelectCustomFieldDefinition"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v11/*: any*/),
                      (v12/*: any*/)
                    ],
                    "type": "NumberCustomFieldDefinition"
                  },
                  (v17/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "alias": "customfieldHeaderSupport",
        "args": (v15/*: any*/),
        "concreteType": "CustomFieldDefinitionConnection",
        "kind": "LinkedField",
        "name": "customFieldDefinitionTql",
        "plural": false,
        "selections": [
          {
            "concreteType": "CustomFieldDefinitionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": (v20/*: any*/),
                    "type": "NumberCustomFieldDefinition"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v20/*: any*/),
                    "type": "TextCustomFieldDefinition"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v21/*: any*/),
                    "type": "TextSelectCustomFieldDefinition"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v21/*: any*/),
                    "type": "UserCustomFieldDefinition"
                  },
                  (v17/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "88bca82c398f7c7a30d8d277c61f2dac",
    "id": null,
    "metadata": {},
    "name": "GoalDirectoryQuery",
    "operationKind": "query",
    "text": "query GoalDirectoryQuery(\n  $aaid: String\n  $workspaceId: ID\n  $workspaceUuid: UUID\n  $containerId: String\n) {\n  reportingLines(aaidOrHash: $aaid) {\n    managers {\n      __typename\n    }\n    peers {\n      __typename\n    }\n    reports {\n      __typename\n    }\n  }\n  hasGoals(includeArchived: false, workspaceId: $workspaceId, containerId: $containerId) {\n    hasRecords\n  }\n  customFieldDefinitionTql(q: \"(entityType = GOAL AND (type != String OR hasPredefinedValues = true))\", workspaceUuid: $workspaceUuid, containerId: $containerId) {\n    ...buildCustomFieldResolvers\n  }\n  customfieldHeaderSupport: customFieldDefinitionTql(q: \"entityType = GOAL\", workspaceUuid: $workspaceUuid, containerId: $containerId) {\n    ...GoalDirectoryHeaderColumns\n  }\n}\n\nfragment GoalDirectoryHeaderColumns on CustomFieldDefinitionConnection {\n  edges {\n    node {\n      __typename\n      ... on NumberCustomFieldDefinition {\n        uuid\n        name\n        type\n      }\n      ... on TextCustomFieldDefinition {\n        uuid\n        name\n        type\n      }\n      ... on TextSelectCustomFieldDefinition {\n        uuid\n        name\n        type\n        canSetMultipleValues\n      }\n      ... on UserCustomFieldDefinition {\n        uuid\n        name\n        type\n        canSetMultipleValues\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment buildCustomFieldResolvers on CustomFieldDefinitionConnection {\n  edges {\n    node {\n      __typename\n      ... on UserCustomFieldDefinition {\n        ...buildCustomFieldResolvers_userResolver\n      }\n      ... on TextSelectCustomFieldDefinition {\n        ...buildCustomFieldResolvers_textSelectResolver\n      }\n      ... on NumberCustomFieldDefinition {\n        ...buildCustomFieldResolvers_numberResolver\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment buildCustomFieldResolvers_numberResolver on NumberCustomFieldDefinition {\n  __typename\n  name\n  token\n}\n\nfragment buildCustomFieldResolvers_textSelectResolver on TextSelectCustomFieldDefinition {\n  __typename\n  name\n  token\n  canSetMultipleValues\n  allowedValues {\n    edges {\n      node {\n        value\n        id\n      }\n    }\n  }\n}\n\nfragment buildCustomFieldResolvers_userResolver on UserCustomFieldDefinition {\n  __typename\n  name\n  token\n  canSetMultipleValues\n}\n"
  }
};
})();

(node as any).hash = "8f5b2a4f331241e1a6395f1572191780";

export default node;
